// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .tab-selected[data-v-4e47096d] {\n  border-bottom-width: 2px;\n  border-bottom-color: rgb(var(--vs-primary));\n  border-bottom-style: solid;\n}\n.invalid-feedback[data-v-4e47096d] {\n  font-size: 12px;\n  color: #AD8ABD;\n}\n", ""]);
// Exports
module.exports = exports;
